module.exports = __webpack_public_path__ + "static/img/22.1bfc8749.jpg";